export const CANCELLATION_ENDPOINT = `https://${process.env.NEXT_PUBLIC_CANCELLATION_GATEWAY_DOMAIN_NAME}`;
